import { create } from "zustand"
import { subscribeWithSelector } from "zustand/middleware"

export default create(subscribeWithSelector((set) =>
{
    return {

        phase: 'rest',
        infoPanel: 'null',

        reset: ()=>
        {
            set((state)=>
            {
                {
                var pan0 = document.getElementById('p0')
                var pan1 = document.getElementById('p1')
                var pan2 = document.getElementById('p2')

                if (pan0.classList.contains('show'))
                {
                    pan0.classList.add('hide')
                }
                pan0.classList.remove('show')

                if (pan1.classList.contains('show'))
                {
                    pan1.classList.add('hide')
                }
                pan1.classList.remove('show')
                
                if(pan2.classList.contains('show'))
                {
                    pan2.classList.add('hide')
                }
                pan2.classList.remove('show')
                

                return { phase: 'rest', infoPanel: 'null' }
                }
            })
            
        },

        move: ()=>
        {
            set((state)=>
            {   
                {
                return { phase: 'move'}   
                }    
            })
        },

        p0: ()=>
        {
            set((state)=>
            {
                {
                    var pan0 = document.getElementById('p0')
                    pan0.classList.remove('hide')
                    pan0.classList.add('show')

                    return { infoPanel: '0' }
                }
            })
            
        },

        p1: ()=>
        {
            set((state)=>
            {
                {
                    var pan1 = document.getElementById('p1')
                    pan1.classList.remove('hide')
                    pan1.classList.add('show')

                return { infoPanel: '1' }
                }
            })
            
        },

        p2: ()=>
        {
            set((state)=>
            {
                {
                    var pan2 = document.getElementById('p2')
                    pan2.classList.remove('hide')
                    pan2.classList.add('show')

                return { infoPanel: '2' }
                }
            })
            
        },


    
    }
}))